/* eslint-disable prettier/prettier */
export default {
  dbh_feedback: '反馈',
  dbh_feedback_success_tips: '反馈成功!',
  dbh_feedback_error_tips: '反馈失败!',
  dbh_feedback_tips:
    '我们期待您的反馈，任何关于数据大脑的bug，或者你认为好的建议',
  dbh_feedback_textarea_placeholder: '留下您的反馈',
  dbh_feedback_upload_img_control_label: '上传图片',
  dbh_feedback_upload_img_control_text: '选择图片',
  dbh_feedback_upload_img_control_tips: '支持批量上传',
  dbh_feedback_uploading_text: 'Uploading...',
  dbh_feedback_upload_img_incorrect_format_tips: '文件格式错误',
  dbh_feedback_upload_img_error_msg: '上传失败，请重新上传',
  dbh_feedback_use_feedback_template: '使用反馈模版',
};
